import { CANAL, APP_VERSION } from "../helpers/constants";
import { axiosInstance2 } from "../helpers/axios";

const userAgent = window.navigator.userAgent;

const setProfileImage = (usuario, image, llaveSeguridad) => {
  // El header Authorization se agrega automáticamente mediante el interceptor de axios
  return axiosInstance2
    .post("dashboard/set_profile_image/", {
      image: image,
      usuario: usuario,
      userAgent: userAgent,
      carrierCelular: userAgent,
      canal: CANAL,
      version: APP_VERSION,
      llaveSeguridad: llaveSeguridad,
    })
    .then((res) => {
      const data = res.data;
      return data;
    })
    .catch((err) => {
      console.log("error");
      console.log(err.message);
      return err;
    });
};

export default { setProfileImage };
